<template>
  <modal-wrapper :isOpen="showModal">
    <div class="customModal fade" v-bind:class="{ show: showModal }">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h6 class="modal-title">Add Time Card</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              v-on:click="parentCloseAddModal()"
            >
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-6">
                <h3 class="float-left">{{ selectedEmployee.name }}</h3>
              </div>
              <div class="col-6"></div>
            </div>
            <div v-if="!addComment.showCommentScreen">
              <div
                class="row"
                v-for="(time, index) in timeCardTimes"
                v-bind:key="index"
              >
                <div class="col-6">
                  <div class="form-group">
                    <label>Time Range:</label>
                    <el-date-picker
                      v-model="time.times"
                      type="datetimerange"
                      start-placeholder="Start Date"
                      end-placeholder="End Date"
                      prefix-icon="null"
                    ></el-date-picker>
                    <div class="date-errors position-absolute d-flex">
                    <div v-if="time.dateError" class="small">
                      <span>{{ time.dateMessage }}</span>
                    </div>
                  </div>
                </div>
</div>
                <div :class="jobSpecificTimes ? 'col-2' : 'col-3'">
                  <div class="form-group">
                    <label>Type:</label>
                    <!-- this needs to be a ddl of employees -->
                    <v-select
                      :options="timeSpanTypes"
                      v-model="time.type"
                    ></v-select>
                    <div v-if="time.typeError" class="small position-absolute">
                      <span>{{ time.typeMessage }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="jobSpecificTimes" class="col-2">
                  <div class="form-group">
                    <label>Job:</label>
                    <v-select
                      :options="jobs"
                      label="description"
                      v-model="time.job"
                    ></v-select>
                    <div v-if="time.jobError" class="small position-absolute">
                      <span>{{ time.jobMessage }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-1 mt-auto">
                  <button
                    type="button"
                    class="btn bg-primary mb-3 inlineButton"
                    v-on:click="removeTime(index)"
                  >
                    <i class="icon-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="showAddAlert">
              <span id="span_editUser_alertDetail">{{ timeCardMessage }}</span>
            </div>
            <div class="row" v-if="!addComment.showCommentScreen">
              <div class="col-12">
                <button
                  type="button"
                  class="btn bg-primary"
                  v-on:click="addTime()"
                >
                  <i class="icon-plus3 mr-2"></i>
                  Add Time
                </button>
              </div>
            </div>
            <div v-if="addComment.showCommentScreen">
              <div class="form-group" style="display: grid;">
                <div
                  v-for="(comment, index) in tempComments"
                  v-bind:key="index"
                >
                  <div
                    class="mb-2 d-inline-grid text-left"
                    v-bind:class="'float-right speech-bubble-mine'"
                  >
                    <span>
                      <strong>{{ comment.commentBy }}:</strong>
                    </span>
                    <span>{{ comment.commentDate }}</span>
                    <p class="mt-2">
                      {{ comment.comment }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div
              v-if="addComment.showCommentScreen"
              class="row mt-3"
              style="margin:auto; margin-left: 0px;"
            >
              <div class="col-12">
                <label class="">Why was the edit made:</label>
              </div>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  placeholder="comment..."
                  v-model="addComment.comment"
                  v-on:keyup="checkforEnter"
                />
              </div>
              <div class="col-2">
                <button
                  type="button"
                  class="btn bg-primary"
                  v-on:click="addCommentToList()"
                >
                  Add
                </button>
              </div>
              <label
                class="validation-invalid-label"
                for="basic"
                v-bind:class="!addComment.error ? 'hidden' : null"
              >
                {{ addComment.errorMessage }}
              </label>
            </div>
            <div class="row">
              <button
                type="button"
                class="btn btn-link"
                data-dismiss="modal"
                v-on:click="parentCloseAddModal()"
              >
                Close
              </button>
              <button
                type="button"
                class="btn bg-primary"
                v-on:click="switchToComment()"
                v-if="!addComment.showCommentScreen"
              >
                Next
              </button>
              <button
                type="button"
                class="btn bg-primary "
                :disabled="saveButtonDisabled"
                v-on:click="submitAddTimeCard()"
                v-if="addComment.showCommentScreen"
              >
                <spring-spinner
                  :animation-duration="3000"
                  :size="15"
                  color="white"
                  v-if="addComment.showCommentScreen && saveButtonDisabled"
                />

                <div v-else>Save Changes</div>
              </button>
            </div>
          </div>

          <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-link" data-dismiss="modal" v-on:click="parentCloseAddModal()">Close</button>
                    <button type="button" class="btn bg-primary" v-on:click="submitAddTimeCard()">Create</button>
                </div>  -->
        </div>
      </div>
    </div>
  </modal-wrapper>
</template>

<script>
import { db } from '../assets/js/firebase/db.js';
import moment from 'moment';
import { SpringSpinner } from 'epic-spinners';
import { mapState } from 'vuex';
import ModalWrapper from './modalWrapper.vue';

export default {
  name: 'addTimeCardModal',
  props: {
    selectedEmployee: Object,
    showModal: {
      type: Boolean,
      default: false
    },
    searchDate: Date
  },
  components: {
    SpringSpinner,
    ModalWrapper
  },
  data() {
    return {
      timeCardTimes: [
        {
          dateError: false,
          dateMessage: null,
          typeError: false,
          typeMessage: null,
          jobError: false,
          jobMessage: null,
          times: [this.searchDate, this.searchDate],
          
        }
      ],
      timeSpanTypes: [],
      timeCardMessage: null,
      showAddAlert: false,
      saveButtonDisabled: false,
      addComment: {
        comment: null,
        commentBy: null,
        commentDate: null,
        error: false,
        errorMessage: null,
        showCommentScreen: false
      },
      tempComments: [],
      allUserTimeCardsTimes: [],
      
    };
  },
  methods: {
    parentCloseAddModal: function() {
      //this emits an event to the parent, so the parent method is called when this method is called.
      //We are doing this so we can have the modal reside in the parent component, and open it from this child component.
      this.$emit('closeAddModal');
    },
    addTime: function() {
      this.timeCardTimes.push({
        startTime: '',
        endTime: ''
      });
    },
    removeTime: function(index) {
      this.timeCardTimes.splice(index, 1);
    },
    submitAddTimeCard: async function() {
      if (this.validateComments() == true) {
        this.saveButtonDisabled = true;

        //check to see if a timecard exists for this day for this employee first.
        await db
          .collection('timeCards')
          .where(
            'date',
            '>=',
            moment(this.timeCardTimes[0].times[0])
              .startOf('day')
              .toDate()
          )
          .where(
            'date',
            '<=',
            moment(this.timeCardTimes[0].times[0])
              .endOf('day')
              .toDate()
          )
          .where('user', '==', this.selectedEmployee.id)
          .get()
          .then(async querySnapshot => {
            if (querySnapshot.size >= 1) {
              //time card already exists.
              this.showError(
                `Time card already exists on this day for this user.`
              );
              this.saveButtonDisabled = false;
            } else {
              //add the time card data here
              let timesArg = [];
              for (let i = 0; i <= this.timeCardTimes.length - 1; i++) {
                let updateTimes = {};
                updateTimes.startTime = this.timeCardTimes[i].times[0];
                updateTimes.endTime = this.timeCardTimes[i].times[1];
                updateTimes.type = this.timeCardTimes[i].type;
                if (this.jobSpecificTimes) {
                  updateTimes.job = this.timeCardTimes[i].job
                    ? this.timeCardTimes[i].job.id
                    : null;
                }
                timesArg.push(updateTimes);
              }

              let formattedComments = this.tempComments.map(
                ({ commentDate, ...rest }) => ({
                  ...rest,
                  commentDate: new Date(commentDate)
                })
              );

              let addData = {
                approved: false,
                company: this.$store.state.userCompany,
                date: moment(this.timeCardTimes[0].times[0]).toDate(),
                name: this.selectedEmployee.name,
                times: timesArg,
                type: this.selectedEmployee.type,
                userCategory: this.selectedEmployee.userCategory,
                user: this.selectedEmployee.id,
                vacation: this.selectedEmployee.vacation,
                averagingAgreement: this.selectedEmployee.averagingAgreement
              };
              if (formattedComments.length > 0) {
                addData['editComment'] = formattedComments;
              }

              //check to see if the user has an averaging agreement and if timecard being added is within the time span for that agreement
              if (addData.averagingAgreement) {
                let docAA = await db
                  .collection(
                    `companySettings/${addData.averagingAgreement.companySettingsID}/averagingAgreements`
                  )
                  .doc(addData.averagingAgreement.docID)
                  .get();
                let today = moment(this.timeCardTimes[0].times[0])
                  .startOf('day')
                  .format();
                let startDate = moment(
                  docAA.data().initialStartDate.toDate()
                ).format();
                let endDate = moment(docAA.data().startDate.toDate())
                  .add(docAA.data().timeFrame, docAA.data().timeFrameUnit)
                  .subtract(1, 'days')
                  .format();
                //if timecard is not within the timespan for the users averaging agreement, or averaging agreement is not enabled, add it as a normal timecard
                if (
                  today < startDate ||
                  today > endDate ||
                  docAA.data().enabled !== true
                ) {
                  addData.averagingAgreement = null;
                }
              }

              db.collection('timeCards')
                .add(addData)
                .then(() => {
                  this.showSuccess('Time card successfully added.');
                  this.$emit('reloadCards');
                  this.parentCloseAddModal();
                  this.saveButtonDisabled = false;
                })
                .catch(err => {
                  console.log(`Error updating time card: ${err}`);
                  this.showError('Error adding time card');
                  this.saveButtonDisabled = false;
                });
            }
          })
          .catch(err => {
            console.log(`Error getting time card data: ${err}`);
            this.showError(
              `Time card not added. Error getting time card data.`
            );
            this.saveButtonDisabled = false;
          });
      }
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    validateTimeCardAdd: function() {
      let flag = true;
      for (let i = 0; i <= this.timeCardTimes.length - 1; i++) {
        //validate the dates aren't empty
        if (this.timeCardTimes[i].times == null) {
          this.timeCardTimes[i].dateError = true;
          this.timeCardTimes[i].dateMessage = 'Dates cannot be empty.';
          flag = false;
        } else {
          this.timeCardTimes[i].dateError = false;
        }
        //validate the type isn't empty.
        if (this.timeCardTimes[i].type == null) {
          this.timeCardTimes[i].typeError = true;
          this.timeCardTimes[i].typeMessage = 'Type cannot be empty.';
          flag = false;
        } else {
          this.timeCardTimes[i].typeError = false;
        }
        //validate the job isn't empty
        // if (this.jobSpecificTimes) {
        //   if (!this.timeCardTimes[i].job) {
        //     this.timeCardTimes[i].jobError = true;
        //     this.timeCardTimes[i].jobMessage = 'Job cannot be empty.';
        //     flag = false;
        //   } else {
        //     this.timeCardTimes[i].jobError = false;
        //   }
        // }
      }
      return flag;
    },
    switchToComment: function() {
      //validate the edit. If it is not valid, don't send the user to the comment screen.
      if (this.validateTimeCardAdd() == true) {
        //loop through and format the dates.
        let comments = [];
        if (this.passedEditComment != null) {
          this.passedEditComment.forEach(comment => {
            comments.push({
              comment: comment.comment,
              commentBy: comment.commentBy,
              commentDate: moment(
                comment.commentDate.nanoseconds != undefined
                  ? comment.commentDate.toDate()
                  : comment.commentDate
              ).format('MMM DD, YY hh:mm')
            });
          });
          this.tempComments = comments;
        }
        this.addComment.showCommentScreen = true;
      }
    },
    checkforEnter: function(e) {
      //if the keypressed is enter, then call the add comment function.
      if (e.keyCode === 13) {
        this.addCommentToList();
      }
    },
    addCommentToList: function() {
      if (
        this.addComment.comment != null ||
        this.addComment.comment != undefined
      ) {
        if (this.addComment.comment.trim() != '') {
          //we aren't going to actually update the comment here, just add it to the list.
          this.tempComments.push({
            comment: this.addComment.comment,
            commentBy: this.$store.state.userName,
            commentDate: moment().format('MMM DD, YY hh:mm')
          });
          this.addComment.comment = '';
        }
      }
    },
    validateComments: function() {
      let flag = true;
      try {
        //only do this check if the setting is enabled.
        if (this.$store.state.requireEditComments == 'Yes') {
          //check to make sure the user has left a comment.
          if (
            this.tempComments.length ==
            (this.passedEditComment != null ? this.passedEditComment.length : 0)
          ) {
            flag = false;
            this.addComment.error = true;
            this.addComment.errorMessage =
              'You must leave a comment to edit a time card.';
          } else {
            this.addComment.error = false;
          }
        }
      } catch (err) {
        flag = false;
        this.showError('An unexpected error ocurred.');
      }
      return flag;
    },

  
  },
  computed: mapState(['jobSpecificTimes', 'jobs']),

  mounted: async function() {
            //get the time span types for the timecard edits.
    db.collection('timeSpanTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.timeSpanTypes.push(doc.data().name);
        });
      })
      .catch(err => {
        console.log(`Error getting time span types: ${err}`);
      });
  },
};
</script>
<style>
.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100% - 40px);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}
</style>